import { createRequestActionTypes } from "../../../shared/utility";

export const ProductGroupActions = {
    fetchProductGroups: createRequestActionTypes('FETCH_PRODUCT_GROUPS'),
    createProductGroup: createRequestActionTypes('CREATE_PRODUCT_GROUP'),
    updateProductGroup: createRequestActionTypes('UPDATE_PRODUCT_GROUP'),
    fetchProductsForBrand: createRequestActionTypes('FETCH_PRODUCTS_FOR_BRAND'),
    fetchSchemesByProductGroup: createRequestActionTypes('FETCH_SCHEMES_BY_PRODUCT_GROUP'),
}